import React, { Fragment, useState } from 'react';

import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import {
	MuiPickersUtilsProvider,
	KeyboardDatePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';

import { IconButton } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';

import customLocales from '@common/customMomentLocales';

import { useTranslation } from '@common/utils';

const customLocale = {
	en: moment.localeData('en-gb'),
	lt: customLocales.lt,
	pl: customLocales.pl,
};

function DatePicker({ onBlur, value, setFieldValue, prop, helperText, error, label, clearable, minDate, maxDate, required, touched }) {
	const tr = useTranslation();
	const { locale } = useSelector(state => state.locale);
	moment.locale(locale, customLocale[locale]);

	const [isOpen, setIsOpen] = useState(false);

	const getProps = (name, initial = null) => {

		return {
			name: name,
			value: typeof value !== 'undefined' ? value : initial,
			onBlur,
			error: touched[name] && Boolean(error),
			helperText: helperText,
		};
	};

	const props = getProps(prop, null);

	return (
		<Fragment>
			<MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={locale}>
				<KeyboardDatePicker
					InputLabelProps={{ shrink: true }}
					variant="inline"
					format="YYYY-MM-DD"
					label={tr(label ? label : 'Date of birth')}
					inputValue={props.value ? null : 'YYYY-MM-DD'}
					autoOk={true}
					minDate={minDate}
					maxDate={maxDate}
					onChange={(date) => {
						setFieldValue(prop, date ? moment(date).format('YYYY-MM-DD') : null, true);
						setIsOpen(false);
					}}
					style={{
						width: '100%',
					}}
					{...props}
					KeyboardButtonProps={{
						onFocus: () => {
							setIsOpen(true);
						},
					}}
					PopoverProps={{
						onFocus: (minDate || minDate) ? () => setIsOpen(true) : undefined,
						disableRestoreFocus: true,
						onClose: () => {
							setIsOpen(false);
						},
					}}
					InputProps={{
						onFocus: (minDate || minDate) ? () => setIsOpen(true) : undefined,
						startAdornment: clearable && props.value && (
							<IconButton onClick={() => setFieldValue(prop, null, true)} style={{ order: 1, position: 'absolute', right: '10%' }}>
								<ClearIcon color="disabled" fontSize="small" />
							</IconButton>
						),
					}}
					open={isOpen}
					required={required}
				/>
			</MuiPickersUtilsProvider>
		</Fragment>
	);
}

DatePicker.propTypes = {
	values: PropTypes.object,
	setFieldValue: PropTypes.func,
	props: PropTypes.object,
	prop: PropTypes.string.isRequired,
	value: PropTypes.string,
	onBlur: PropTypes.func,
	touched: PropTypes.object,
	error: PropTypes.string,
	helperText: PropTypes.string,
	label: PropTypes.string,
	clearable: PropTypes.bool,
	minDate: PropTypes.string,
	maxDate: PropTypes.string,
	required: PropTypes.bool,
};

export default DatePicker;
